import { SVGProps, memo } from 'react';

const EmptyCheckboxOnboard = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width='42'
    height='42'
    viewBox='0 0 42 42'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <g clip-path='url(#clip0_270_2808)'>
      <rect
        x='12.877'
        y='13'
        width='16.1233'
        height='15.9724'
        rx='6'
        stroke='black'
        stroke-opacity='0.56'
        stroke-width='2'
      />
    </g>
    <defs>
      <clipPath id='clip0_270_2808'>
        <rect width='42' height='42' fill='white' />
      </clipPath>
    </defs>
  </svg>
);

export default memo(EmptyCheckboxOnboard);
